export const ADMIN_DATA = {
  data: null,
  loading: false,
  error: false,
}

export const USER_ACTIONS = {
  value: null,
  error: null,
}

export const INVOICES = {
  loading: false,
  data: null,
  error: null,
}

export const initialState = {
  adminData: ADMIN_DATA,
  userActions: USER_ACTIONS,
  invoices: INVOICES,
}
